(function () {

  'use strict';

  // Extends FolderModel with following attributes:
  // - loading: whether the folder's children are currently being loaded
  // - loaded: whether the folder's children have been loaded
  // - loadError: whether there was an error loading the folder's children
  // - open: whether the folder is currently open

  function pxSitesTree(
    $filter, $rootScope, toastr, SiteService, SitesProviderService, FolderModel, EventServiceEvents, SitesListPaging
  ) {
    return {
      restrict: 'E',
      scope: {
        me: '=me',
        resizing: '=resizing'
      },
      templateUrl: 'app/components/sites/sitesTree/sitesTree.template.html',
      controller: ['$scope', function ($scope) {

        this.me = $scope.me;
        this.siteTreeUpdating = false;
        this.dragging = false;

        $scope.siteTree = undefined;

        (function () {
          getRootSiteItems();
          setListeners();
        })();

        function getRootSiteItems() {
          getSiteItemsSorted('/')
            .then(function (siteItems) {
              $scope.siteTree = siteItems;
              restoreOpenStateOfFolders(siteItems);
            })
            .catch(function () {
            });
        }

        function getChildSiteItems(folder) {
          folder.loading = true;
          getSiteItemsSorted(folder.childPath)
            .then(function (siteItems) {
              folder.loadError = false;
              folder.loaded = true;
              folder.children = siteItems;
              restoreOpenStateOfFolders(siteItems);
            })
            .catch(function () {
              folder.loadError = true;
              folder.loaded = false;
              folder.children = undefined;
            })
            .finally(function () {
              folder.loading = false;
            });
        }

        function getSiteItemsSorted(path) {
          const sitesListPaging = new SitesListPaging();
          sitesListPaging.pagingCriteria.path = path;
          return SitesProviderService.getSitesPaged(sitesListPaging)
            .then(function (sitesPaged) {
              return sortSiteItems(sitesPaged.sites);
            });
        }

        function sortSiteItems(siteItems) {
          return siteItems.sort(function (siteItem1, siteItem2) {
            if (siteItem1.type === siteItem2.type) {
              return siteItem1.name.localeCompare(siteItem2.name);
            } else {
              return siteItem1.type === 'folder' ? -1 : 1;
            }
          });
        }

        function restoreOpenStateOfFolders(siteItems) {
          const openFolderIds = SiteService.retrieveOpenFolderIds();
          siteItems.forEach(function (siteItem) {
            if (siteItem.type === 'folder' && openFolderIds[siteItem.id]) {
              siteItem.open = true;
              getChildSiteItems(siteItem);
            }
          });
        }

        this.onFolderClick = function (event, folder) {
          $scope.closeAllMenues();
          selectSite(folder);
          toggleFolderOpenState(folder);
          if (folder.open && !folder.loaded) {
            getChildSiteItems(folder);
          }
        };

        this.onFolderRightClick = function (event, folder) {
          clearTooltip();
          openFolderContextMenu(event, folder);
        };

        this.onSiteClick = function (event, site) {
          $scope.closeAllMenues();
          selectSite(site);
        };

        this.onSiteRightClick = function (event, site) {
          clearTooltip();
          openSiteContextMenu(event, site);
        };

        this.hasSiteManager = function (item) {
          return !!item.links['px:siteAdminGroup'];
        };

        function selectSite(site) {
          SiteService.putSiteInStorage(site);
          $rootScope.$broadcast('UPDATE_SELECTED_SITES', site);
        }

        function toggleFolderOpenState(folder) {
          folder.open = !folder.open;
          if (folder.open) {
            SiteService.storeOpenFolderId(folder.id);
          } else {
            SiteService.removeOpenFolderId(folder.id);
          }
        }

        function getIdFromUrl(url) {
          const index = url.lastIndexOf('/');
          return index !== -1 ? url.substring(index + 1) : undefined;
        }

        function getSiteItemByPath(path) {
          if (path === '/') {
            return null; // Root folder does not have a corresponding site item.
          }
          let foundSiteItem;
          let siteItems = $scope.siteTree;
          const pathParts = path.split('/').filter(part => part);
          while (pathParts.length) {
            if (!siteItems) return undefined; // Site item not found in tree.
            const pathPart = pathParts.shift();
            foundSiteItem = siteItems.find(site => site.id === pathPart);
            if (!foundSiteItem) return undefined; // Site item not found in tree.
            siteItems = foundSiteItem.children;
          }
          return foundSiteItem;
        }

        function findSiteItemById(id, siteItems) {
          siteItems = siteItems || $scope.siteTree;
          let foundItem = siteItems.find(siteItem => siteItem.id === id);
          if (foundItem) return foundItem;
          for (let i = 0; i < siteItems.length; i++) {
            const siteItem = siteItems[i];
            if (siteItem.type === 'folder' && siteItem.children) {
              foundItem = findSiteItemById(id, siteItem.children);
              if (foundItem) return foundItem;
            }
          }
          return undefined;
        }

        function removeSiteItemFromTree(siteItem) {
          if (siteItem.parentId) {
            const parentFolder = findSiteItemById(siteItem.parentId);
            const index = parentFolder.children.indexOf(siteItem);
            parentFolder.children.splice(index, 1);
          } else {
            const index = $scope.siteTree.indexOf(siteItem);
            $scope.siteTree.splice(index, 1);
          }
        }

        function addSiteItemToTree(siteItem, parentFolder) {
          if (parentFolder) {
            parentFolder.children.push(siteItem);
            sortSiteItems(parentFolder.children);
          } else {
            $scope.siteTree.push(siteItem);
            sortSiteItems($scope.siteTree);
          }
        }

        function updateSiteItemInTree(originalSiteItem, updatedSiteItem) {
          if (originalSiteItem.path === updatedSiteItem.path) {
            const siteitems = originalSiteItem.parentId ? findSiteItemById(originalSiteItem.parentId).children : $scope.siteTree;
            const index = siteitems.indexOf(originalSiteItem);
            siteitems.splice(index, 1, updatedSiteItem);
            if (originalSiteItem.name !== updatedSiteItem.name) {
              sortSiteItems(siteitems);
            }
          } else {
            const siteitems = updatedSiteItem.parentId ? findSiteItemById(updatedSiteItem.parentId).children : $scope.siteTree;
            const index = siteitems.indexOf(originalSiteItem);
            siteitems.splice(index, 1, updatedSiteItem);
            sortSiteItems(siteitems);
          }
        }

        // TOOLTIP STUFF

        this.showTooltip = function (showTip, position, tooltipScope) {
          if (showTip && !$scope.resizing && !this.dragging) {
            switch (tooltipScope) {
              case 'folder':
                folderTooltip(position);
                break;
              case 'site':
                siteTooltip(position);
                break;
            }
          } else {
            clearTooltip();
          }
        };

        function siteTooltip(position) {
          $scope.tooltipContent = {
            title: 'Site',
            type: 'multipleStatements',
            tooltips: [
              { icon: null, tip: 'ToolHintSelect' },
              { icon: null, tip: 'ToolHintMultiSelect' },
              { icon: null, tip: 'ToolHintOpenMenu' }
            ]
          };
          $scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 }
          };
        }

        function folderTooltip(position) {
          $scope.tooltipContent = {
            title: 'Folder',
            type: 'multipleStatements',
            tooltips: [
              { icon: null, tip: 'ToolHintSelect' },
              { icon: null, tip: 'ToolHintOpenMenu' }
            ]
          };
          $scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 }
          };
        }

        function clearTooltip() {
          $scope.tooltipContent = null;
          $scope.tooltipObject = null;
        }

        // DRAG AND DROP STUFF

        this.onDndDragStart = function (event) {
          clearTooltip();
          this.dragging = true;
        };

        this.onDndDragStop = function (event, dropEffect) {
          clearTooltip();
          this.dragging = false;
        };

        this.onDndMoved = function (event, items, index) {
          // Remove the item from the original array.
          items.splice(index, 1);
        };

        this.onDndDrop = function (event, item, target) {
          event.stopPropagation();

          // Do not allow moving to the same location.
          const targetPath = target?.childPath || '/';
          if (item.path === targetPath) {
            return false;
          }

          // Do not allow moving if it would exceed maximum folder depth.
          const targetLevel = targetPath.split('/').length - 1;
          const itemDepth = getBranchDepth(item);
          if ((itemDepth + targetLevel) > 5) {
            toastr.warning($filter('translate')('MoveFailedTooDeepNesting'));
            return false;
          }

          moveSiteItemInTree.call(this, item, targetPath);
          return item;
        };

        function getBranchDepth(node) {
          if (node.type !== 'folder') {
            return 1;
          }
          if (!node.children || !node.children.length) {
            return 2;
          }
          let maxDepth = 0;
          node.children.forEach(function (n) {
            maxDepth = Math.max(maxDepth, getBranchDepth(n));
          });
          return maxDepth + 1;
        }

        function moveSiteItemInTree(siteItem, targetPath) {
          this.siteTreeUpdating = true;
          new FolderModel(siteItem.info).moveSite(siteItem, targetPath)
            .then(function (response) {
              // Site moved successfully.
            })
            .catch(function (response) {
              moveBackSiteItemInTree(siteItem, targetPath);
              if (response.data.errorCode === 'TOO_DEEP_SITE_NESTING') {
                toastr.warning($filter('translate')('MoveFailedTooDeepNesting'));
              } else {
                toastr.error($filter('translate')('ERROR'));
              }
            })
            .finally(() => {
              this.siteTreeUpdating = false;
            });
        }

        function moveBackSiteItemInTree(siteItem, targetPath) {
          const targetFolder = getSiteItemByPath(targetPath);
          if (targetFolder !== undefined) {
            const targetFolderChildren = targetFolder === null ? $scope.siteTree : targetFolder.children;
            const index = targetFolderChildren.indexOf(siteItem);
            if (index !== -1) {
              targetFolderChildren.splice(index, 1);
              const sourceFolder = getSiteItemByPath(siteItem.path);
              if (sourceFolder !== undefined) {
                addSiteItemToTree(siteItem, sourceFolder);
              }
            }
          }
        }

        // CONTEXT MENUS

        function openFolderContextMenu(event, folder) {
          $scope.closeAllMenues(null, null, null);
          $rootScope.$broadcast('SITE_TREE_CONTEXT_CONTROL');
          const canCreateSubfolder = [
            { title: 'FolderName',           selected: false, type: 'rename',          breaker: false, order: 6, disabled: $scope.me.isSystemObserver() },
            { title: 'SiteManagerGroups',    selected: false, type: 'siteManagers',    breaker: true,  order: 5, bypassCloseOutside: true },
            { title: 'AddSiteManagerGroups', selected: false, type: 'addSiteManagers', breaker: true,  order: 4, disabled: $scope.me.isSystemObserver(), bypassCloseOutside: true },
            { title: 'NewFolder',            selected: false, type: 'COLLECTION',      breaker: false, order: 3, disabled: $scope.me.isSystemObserver() },
            { title: 'CreateSite',           selected: false, type: 'SINGLE',          breaker: true,  order: 2, disabled: $scope.me.isSystemObserver() },
            { title: 'DeleteFolder',         selected: false, type: 'deleteSite',      breaker: false, order: 1, disabled: $scope.me.isSystemObserver() }
          ];
          if (folder.level === 3) {
            canCreateSubfolder.splice(3, 1);
          }
          $scope.menuContent = {
            menuItems: canCreateSubfolder,
            context: folder,
            icon: 'icon-folder',
            sizeClass: 'size100',
            type: 'FOLDER'
          };
          $scope.menuSpecs = {
            position: { left: event.clientX, top: event.clientY },
            type: 'FOLDER'
          };
        }

        function openSiteContextMenu(event, site) {
          $scope.closeAllMenues(null, null, null);
          $rootScope.$broadcast('SITE_TREE_CONTEXT_CONTROL');
          $scope.menuContent = {
            menuItems: [
              { title: 'SiteName',             selected: false, type: 'rename',          breaker: false, order: 6, disabled: $scope.me.isSystemObserver() },
              { title: 'SiteManagerGroups',    selected: false, type: 'siteManagers',    breaker: false, order: 5, bypassCloseOutside: true },
              { title: 'Networks',             selected: false, type: 'siteNetworks',    breaker: true,  order: 4 },
              { title: 'AddSiteManagerGroups', selected: false, type: 'addSiteManagers', breaker: false, order: 3, disabled: $scope.me.isSystemObserver(), bypassCloseOutside: true },
              { title: 'AddNetworks',          selected: false, type: 'addNetworks',     breaker: true,  order: 2, disabled: $scope.me.isSystemObserver() },
              { title: 'DeleteSite',           selected: false, type: 'deleteSite',      breaker: false, order: 1, disabled: $scope.me.isSystemObserver() }
            ],
            context: site,
            icon: 'icon-pin',
            sizeClass: 'size115',
            type: 'SITE'
          };
          $scope.menuSpecs = {
            position: { left: event.clientX, top: event.clientY },
            type: 'SITE'
          };
        }

        $scope.closeAllMenues = function (selectedContextMenuItem, contextContentPosition, contextContent) {
          $scope.menuContent = null;
          $scope.menuSpecs = null;
          $scope.selectedContextMenuItem = selectedContextMenuItem;
          $scope.contextContentPosition = contextContentPosition;
          $scope.contextContent = contextContent;
          $scope.auxiliaries = { me: $scope.me };
        };

        // LISTENERS

        function setListeners() {

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_SITE_CREATED, function (event, data) {
            if (!data.isPartOfBatch) {
              SitesProviderService.getSiteOnly(data.site)
                .then(function (siteItem) {
                  if (siteItem.parentId) {
                    const parentFolder = findSiteItemById(siteItem.parentId);
                    if (parentFolder && parentFolder.loaded) {
                      addSiteItemToTree(siteItem, parentFolder);
                    }
                  } else {
                    addSiteItemToTree(siteItem);
                  }
                })
                .catch(function () {
                });
            }
          });

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_SITE_UPDATED, function (event, data) {
            if (!data.isPartOfBatch) {
              const originalSiteItem = findSiteItemById(getIdFromUrl(data.site));
              if (originalSiteItem) {
                SitesProviderService.getSiteOnly(data.site)
                  .then(function (updatedSiteItem) {
                    updateSiteItemInTree(originalSiteItem, updatedSiteItem);
                  })
                  .catch(function () {
                  });
              }
            }
          });

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_SITE_DELETED, function (event, data) {
            if (!data.isPartOfBatch) {
              const siteItem = findSiteItemById(getIdFromUrl(data.site));
              if (siteItem) {
                removeSiteItemFromTree(siteItem);
              }
            }
          });

        }

        const deregisterSiteListContextControlListener = $rootScope.$on('SITE_LIST_CONTEXT_CONTROL', function () {
          $scope.closeAllMenues(null, null, null);
        });

        const deregisterSiteContextControlListener = $rootScope.$on('SITE_CONTEXT_CONTROL', function () {
          $scope.closeAllMenues(null, null, null);
        });

        $scope.$on('$destroy', function () {
          deregisterSiteListContextControlListener();
          deregisterSiteContextControlListener();
        });

      }]
    };
  }

  pxSitesTree.$inject = [
    '$filter', '$rootScope', 'toastr', 'SiteService', 'SitesProviderService', 'FolderModel', 'EventServiceEvents', 'SitesListPaging'
  ];

  angular
    .module('printix-admin')
    .directive('pxSitesTree', pxSitesTree);

})();
